import CountUp from 'react-countup';
import {ArrowUpRight, CheckCircle, XCircle} from 'lucide-react';
import React, {useCallback, useEffect, useState} from "react";
import {APIv1} from "../../../../api";
import {Skeleton} from "antd";
import {useTranslation} from 'react-i18next';
import TransactionNumberCard from "../TransactionNumberCard";
import DeviceHottest from "../DeviceHottest/DeviceHottest";
import './TransactionFinancial.css';


const TransactionFinancialCard = ({startPeriod, endPeriod}) => {
    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [fetchedData, setFetchedData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [deviceTotal, setDeviceTotal] = useState(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            let url = (startPeriod && endPeriod) ? `/analysis/transactions/amount/?start_period=${startPeriod}&end_period=${endPeriod}` : '/analysis/transactions/amount/'
            const response = await APIv1.get(url, {
                headers: {
                    Authorization: `Token ${userData.token}`,
                },
            });
            const responseData = response.data;

            setFetchedData({
                'successAmount': responseData.success,
            });

            const countUrl = (startPeriod && endPeriod) ? `/analysis/transactions/counts/?start_period=${startPeriod}&end_period=${endPeriod}` : '/analysis/transactions/counts/'
            const countResponse = await APIv1.get(countUrl, {
                headers: {
                    Authorization: `Token ${userData.token}`,
                },
            });
            const countResponseData = countResponse.data;

            setFetchedData((prevData) => ({
                ...prevData,
                'successCount': countResponseData.success,
                'failureCount': countResponseData.failure,
            }));

        } catch (error) {
            console.error('Error fetching user data:', error);
        } finally {
            setLoading(false);
        }
    }, [userData.token, startPeriod, endPeriod]);

    useEffect(() => {
        if (!userData.token) return;

        fetchData()
    }, [userData.token, startPeriod, endPeriod])

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    return (
        <div className="analysis__metrics__card analysis__metrics__card-transaction__financial">
            <div className="analysis__metrics__card-header">
                <h2>{t("analysis.numbersStats.mainTitles.transactionsFinancialTitle")}</h2>
                <div className="analysis__metrics__card-header-side">
                    <h2>{t("analysis.deviceTemperature.groupTitle")}</h2>
                    {deviceTotal !== null && (
                        <span className="analysis__metrics__card-header-total">
                            {`${deviceTotal} ${t("analysis.deviceTemperature.subLabel")}`}
                        </span>
                    )}
                </div>
            </div>
            <div className="analysis__metrics__container">
                <div className="analysis__metrics__card">
                    <ArrowUpRight className="analysis__metrics__icon-bg" aria-hidden="true"/>
                    <div className="analysis__metrics__count-badges">
                        <div className="analysis__metrics__count-badge-row">
                            <div className="analysis__metrics__qty-badge">{t("common.count")}</div>
                            <div className="analysis__metrics__count-badge">
                                <CheckCircle className="analysis__metrics__count-badge-icon"/>
                                {loading ? (
                                    <Skeleton.Button active style={{width: 42, height: 18}}/>
                                ) : (
                                    <CountUp end={fetchedData.successCount} duration={2.5}/>
                                )}
                            </div>
                        </div>
                        <div className="analysis__metrics__count-badge analysis__metrics__count-badge--error">
                            <XCircle className="analysis__metrics__count-badge-icon"/>
                            {loading ? (
                                <Skeleton.Button active style={{width: 42, height: 18}}/>
                            ) : (
                                <CountUp end={fetchedData.failureCount} duration={2.5}/>
                            )}
                        </div>
                    </div>
                    <span className="analysis__metrics__label">{t("common.success")}</span>
                    <div className="analysis__metrics__value analysis__metrics__value--success">
                        {/*<ArrowUpRight className="analysis__metrics__icon"/>*/}
                        {loading ? (
                            <Skeleton.Button active style={{width: 100, height: 24}}/>
                        ) : (
                            <CountUp
                                end={fetchedData.successAmount}
                                duration={2.5}
                                separator=","
                                suffix=" UZS"
                            />
                        )}
                    </div>
                    <TransactionNumberCard startPeriod={startPeriod} endPeriod={endPeriod} embedded/>
                </div>
                <div className="analysis__metrics__empty-slot">
                    <DeviceHottest onTotalChange={setDeviceTotal}/>
                </div>
            </div>
        </div>
    )
};

export default TransactionFinancialCard;
